export default "__VITE_ASSET__D6MAM4vb__"